/* eslint-disable @typescript-eslint/no-explicit-any */
import { type PropertyValue } from '@/types'
import { useRouter } from 'next/router'
import { useMemo, type ReactNode } from 'react'
interface FilterGroup {
  className?: string
  inputClassName?: string
  option: PropertyValue
  children: ReactNode
  onChange: (e: { name: string; value: string | null }[]) => void
  activeOption?: {
    name: string
    values: string[]
  }
  type: string
}
export function FilterGroup({
  className = '',
  type,
  children,
  option,
  activeOption,
  inputClassName,
  onChange,
}: FilterGroup) {
  const router = useRouter()
  const handleFilterChange = (ev: any) => {
    const { value } = ev.target
    if (activeOption) {
      const hasValue = activeOption.values.includes(value)
      const newValues = hasValue
        ? activeOption.values.filter(v => v !== value).join()
        : [...activeOption.values, value].join()

      onChange([
        {
          name: activeOption.name,
          value: newValues || null,
        },
      ])
    }
  }

  const checked = useMemo(() => {
    return activeOption?.values.includes(option.value.vi) || false
  }, [router.query])

  return (
    <>
      {type === 'checkbox' ? (
        <div
          className={`rounded-container type-layout-prefix m-0 flex min-w-[96px] cursor-pointer flex-wrap gap-2 p-0 text-left uppercase ${className}`}
        >
          <input
            id={`checkbox-${option.value.vi}`}
            type='checkbox'
            value={option.value.vi}
            checked={checked}
            onChange={e => {
              handleFilterChange(e)
            }}
            className={`relative box-border h-4 w-4 max-w-[24px] flex-[24px] appearance-none rounded-[5px] border bg-white checked:border-none checked:bg-blue checked:text-mainBody checked:before:absolute checked:before:left-[6px] checked:before:top-[4px] checked:before:content-[url('/check.svg')] focus:checked:bg-blue  ${
              inputClassName ? inputClassName : ''
            }`}
          />
          <label
            htmlFor={`checkbox-${option.value.vi}`}
            className='control--label for-checkbox max-w-[calc(100%-36px)] flex-[calc(100%-36px)] cursor-pointer'
          >
            {children}
          </label>
        </div>
      ) : (
        <>
          <input
            className=' invisible absolute left-[-99999px] m-[-1px] h-[1px] p-0'
            id={`filter-${option.value.vi}`}
            type='checkbox'
            value={option.value.vi}
            checked={checked}
            onChange={e => {
              handleFilterChange(e)
            }}
          />
          <label
            htmlFor={`filter-${option.value.vi}`}
            className='control--label for-checkbox'
          >
            <div
              className={`m-0 flex h-10 min-w-[80px] cursor-pointer items-center justify-center rounded-lg border px-1 ${
                checked
                  ? 'border-primary-base bg-primary-base text-white'
                  : 'border-dark-200 bg-white'
              } rounded-container type-layout-prefix uppercase ${className}`}
            >
              {children}
            </div>
          </label>
        </>
      )}
    </>
  )
}

export default FilterGroup
